import {
    fadeIn,
} from '@js/common/customFunctions.js';

document.addEventListener('DOMContentLoaded', () => {
    const hotspot = document.querySelectorAll('.hotspot-component-section');

    hotspot.forEach(section => {
        const popupList = section.querySelector('.hcs-popup-list');
        if (!popupList) {return;}

        const popup = section.querySelector('.hcs-popup');
        const points = section.querySelectorAll('.drag_element');

        // 👉 First: Build popup items
        points.forEach(point => {
            const dragEl = point.querySelector('.point_style');
            if (!dragEl) {return;}

            const htmlContent = dragEl.getAttribute('data-html');
            if (!htmlContent || !htmlContent.trim()) {return;}

            const pinId = point.getAttribute('id');

            const popupItem = document.createElement('div');
            popupItem.classList.add('hcs-popup-item');

            if (pinId) {
                popupItem.setAttribute('data-pin-id', pinId);
            }

            popupItem.innerHTML = htmlContent;
            popupItem.style.display = 'none'; // hide by default

            popupList.appendChild(popupItem);
        });

        const popupItems = popupList.querySelectorAll('.hcs-popup-item');

        // 👉 Then: Attach click events
        points.forEach(point => {
            point.addEventListener('click', () => {
                const pinId = point.getAttribute('id');
                if (!pinId) {return;}

                // Active state
                points.forEach(p => p.classList.remove('active'));
                point.classList.add('active');
                document.body.classList.add('scroll-fixed');

                // Show popup container
                popup ?.classList.add('is-show');

                // Hide all popups first
                popupItems.forEach(item => {
                    item.style.display = 'none';
                });

                // Show matching popup
                const activeItem = popupList.querySelector(`.hcs-popup-item[data-pin-id="${pinId}"]`);

                if (activeItem) {
                    fadeIn(activeItem);
                }
            });
        });

        const closeBtn = section.querySelector('.hcs-popup-close');
        const overlay = section.querySelector('.hcs-popup-overlay');

        const closePopup = () => {
            // Hide popup container
            popup?.classList.remove('is-show');

            // Remove active from all points
            points.forEach(p => p.classList.remove('active'));
            document.body.classList.remove('scroll-fixed');
        };

        // Close on overlay click
        overlay ?.addEventListener('click', closePopup);

        // Close on close button click
        closeBtn ?.addEventListener('click', closePopup);
    });
});